// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"
import Container from "../layout/container"
import History from "./history"
import Mission from "./mission"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"

const Desktop = ({ langKey }) => {
  const data = useStaticQuery(graphql`
    query PicturesDesktopQuery {
      img1: file(relativePath: { eq: "peopleDesktop.png" }) {
        childImageSharp {
          fixed(width: 600, height: 400) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      img2: file(relativePath: { eq: "foundersDesktop.png" }) {
        childImageSharp {
          fixed(width: 574, height: 574) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)

  return (
    <Container>
      <div
        sx={{ display: `flex`, flexDirection: `column`, marginTop: `-5rem` }}
      >
        <div sx={{ display: `flex` }}>
          <History langKey={langKey} />
          <div sx={{}}>
            <Img
              alt=""
              sx={{
                zIndex: 5,
                position: `relative`,
                bottom: `-10%`,
                right: `5%`,
                overflow: `visible !important`,
              }}
              fixed={data.img2.childImageSharp.fixed}
            />
          </div>
        </div>
        <div sx={{ display: `flex` }}>
          <Img
            alt=""
            sx={{ overflow: `visible !important`, zIndex: 5, left: `5%` }}
            fixed={data.img1.childImageSharp.fixed}
          />

          <Mission langKey={langKey} />
        </div>
      </div>
    </Container>
  )
}

export default Desktop
